import { NO, UITextView, UIView } from "uicore-ts"
import { RHButton } from "../../Custom components/RH/RHButton"
import { RHColors, RHFont, RHSpacing } from "../../Custom components/RH/Utils_slop/RHDesignTokens"
import { RHEuroFormatter } from "../../Custom components/RH/Utils_slop/RHEuroFormatter"
import type { RHCPVSummationReport } from "../../SocketClientFunctions"

export class CPVSummationTemplateReportView extends UIView {

    readonly titleLabel = new UITextView(undefined, UITextView.type.header4).configuredWithObject({
        text: "Malli lepingud", isSingleLine: NO, textColor: RHColors.textPrimary
    }).addedAsSubviewToView(this)

    readonly periodLabel = new UITextView().configuredWithObject({
        isSingleLine: NO, textColor: RHColors.textSecondary,
        style: { fontSize: RHFont.sizeSmall, lineHeight: "1.5" }
    }).addedAsSubviewToView(this)

    readonly amountLabel = new UITextView().configuredWithObject({
        isSingleLine: NO, textColor: RHColors.textPrimary,
        style: { fontWeight: RHFont.weightSemibold, lineHeight: "1.5" }
    }).addedAsSubviewToView(this)

    readonly exportButton = new RHButton().configuredWithObject({
        variant: "light", contentPadding: RHSpacing.small,
        titleLabel: { text: "Laadi lepingute XLSX", style: { fontSize: RHFont.sizeSmall } }
    }).addedAsSubviewToView(this)

    readonly exportHelpLabel = new UITextView().configuredWithObject({
        isSingleLine: NO, textColor: RHColors.textSecondary,
        style: { fontSize: RHFont.sizeSmall, lineHeight: "1.5" }
    })

    updateWithReport(report: RHCPVSummationReport) {
        const summary = report.templateSummary
        if (!summary) {
            return
        }
        this.periodLabel.text = `Arvestusperiood ${report.windowStart.split("-").reverse().join(".")} – ${report.windowEnd.split("-").reverse().join(".")}`
        this.amountLabel.text = `Lepingute summa ${RHEuroFormatter.formattedAmount(summary.amountExclVat)} KM-ta · lepingute arv ${summary.contractCount}`
        this.setNeedsLayoutUpToRootView()
    }

    override layoutSubviews() {
        super.layoutSubviews()
        const bounds = this.contentBoundsWithInset(RHSpacing.small)
        bounds
            .rectangleWithHeight(this.titleLabel)
            .assignedAsFrameOfView(this.titleLabel)
            .rectangleForNextRow(RHSpacing.small, this.periodLabel)
            .assignedAsFrameOfView(this.periodLabel)
            .rectangleForNextRow(RHSpacing.small, this.amountLabel)
            .assignedAsFrameOfView(this.amountLabel)
            .rectangleForNextRow(RHSpacing.small, 36)
            .rectangleWithWidth(Math.min(bounds.width, 220))
            .assignedAsFrameOfView(this.exportButton)
            .rectangleWithWidth(bounds.width)
            .IF(this.exportHelpLabel.superview === this)
            .rectangleForNextRow(RHSpacing.small, this.exportHelpLabel)
            .assignedAsFrameOfView(this.exportHelpLabel)
            .ENDIF()
    }
}
